import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePath = defineStore('path', () => {
  const path = ref<any>(null)

  function getPath(){
    return path.value
  }

  function setPath(data: any) {
    path.value = data
  }


  function clear() {
    path.value = null
  }

  return { getPath, setPath, clear }
})
